import { useReactiveVar } from '@apollo/client'
import { ProductType } from '@shared/gql/document-nodes'
import { shoppingCartVar } from 'services/ClientCart/cache'

export const useGetClientCartItemsByType = (productType = ProductType.Product) => {
  const items = useReactiveVar(shoppingCartVar)
  return items.filter((item) => item.productType === productType)
}
